import { render, staticRenderFns } from "./VoucherDialog.vue?vue&type=template&id=55edf67c&scoped=true"
import script from "./VoucherDialog.vue?vue&type=script&lang=ts"
export * from "./VoucherDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55edf67c",
  null
  
)

export default component.exports